import { fork, take } from 'redux-saga/effects'
import { appActions } from './actions'
import history from '../history'

//=====================================
//  WATCHERS
//-------------------------------------

export function* watchNavigateTo() {
  while (true) {
    const { payload } = yield take(appActions.NAVIGATE_TO_PATH);
    yield history.push(payload);
  }
}

//=====================================
//  ROOT
//-------------------------------------

export const appSagas = [
  fork(watchNavigateTo)
]
